import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './DeliveryMapOptions.css';
import Button from '../UI/Button/Button';

class DeliveryMapOptions extends Component {
    render () {        
        return (
            <div className={classes.LoadDeliveryButtons}>
                
                <Button 
                    btnType="Success"
                    clicked={this.props.overview}>Available for Next Delivery</Button>

                <Button 
                    btnType="Success"
                    clicked={this.props.directions}>Unavailable</Button>
            </div>
        );
    }
};

export default DeliveryMapOptions;


// WEBPACK FOOTER //
// ./src/components/DeliveryMapOptions/DeliveryMapOptions.js